<template>
  <b-overlay :show="loading">
    <div class="d-flex justify-content-center align-items-center">
      <div v-tooltip="'Ver detalle'">
        <b-button
          data-cy="details"
          variant="secondary"
          class="btn-icon rounded-circle p-3"
          size="sm"
          v-on:click="onOptionDetailAuction(auction, 'visualize')"
        >
          <feather-icon icon="SearchIcon"/>
        </b-button>
      </div>
      <slot
        name="action-list"
        v-bind:auction="auction"
      >
        <div v-tooltip="'Desplegar acciones'">
          <b-dropdown
            v-has-permission="'ED191'"
            data-cy="gear-button"
            variant="link"
            no-caret
            right
          >
            <template #button-content>
              <feather-icon
                width="24px"
                height="24px"
                icon="SettingsIcon"
                class="align-middle text-body"
              />
            </template>
            <CheckPermission permission="ED180">
              <b-dropdown-item
                v-on:click="onOptionBinnacle(auction)"
                data-cy="binnacle"
              >
                <vs-icon icon="list"/>
                Bitácora
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED178">
              <b-dropdown-item
                v-on:click="openBatchForm(auction)"
                v-if="auction.estado === auctionsStateCode.preparacion"
                data-cy="add-batch"
              >
                <vs-icon icon="add"/>
                Agregar Lote
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED176">
              <b-dropdown-item
                v-on:click="onOptionDetailAuction(auction, 'edit')"
                v-if="canPlanify"
                data-cy="planning-auction"
              >
                <vs-icon icon="content_paste"/>
                {{
                  auction.estado === auctionsStateCode.preparacion
                    ? 'Planificar'
                    : 'Re-Planificar'
                }}
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED192">
              <b-dropdown-item
                v-on:click="goToBatchesFiltered(auction)"
                data-cy="batches"
              >
                <vs-icon icon="search"/>
                Ver Lotes
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED193">
              <b-dropdown-item
                v-on:click="goToReceiptsFiltered(auction)"
                data-cy="receipts"
              >
                <vs-icon icon="search"/>
                Ver Comprobantes
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED177">
              <b-dropdown-item
                v-on:click="showUpdateAuctionAlert(auctionsActionStates.FINALIZAR)"
                v-if="auction.estado === auctionsStateCode.publicada"
                data-cy="auction-update-finalize"
              >
                <vs-icon icon="check_circle"/>
                Finalizar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED194"
              v-if="auction.estado === auctionsStateCode.planificada"
            >
              <b-dropdown-item
                v-on:click="showUpdateAuctionAlert(auctionsActionStates.PUBLICAR)"
                data-cy="auction-update-publish"
              >
                <vs-icon icon="verified_user"/>
                Publicar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED216"
              v-if="auction.estado === auctionsStateCode.creada"
            >
              <b-dropdown-item
                v-on:click="showUpdateAuctionAlert(auctionsActionStates.PREPARAR)"
                data-cy="auction-update-prepare"
                v-if="auction.estado === auctionsStateCode.creada"
              >
                <vs-icon icon="arrow_forward"/>
                Preparar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission
              permission="ED217"
              v-if="auction.estado === auctionsStateCode.preparacion"
            >
              <b-dropdown-item
                v-on:click="showUpdateAuctionAlert(auctionsActionStates.DESPREPARAR)"
                data-cy="auction-update-un-prepare"
                v-if="auction.estado === auctionsStateCode.preparacion"
              >
                <vs-icon icon="arrow_back"/>
                Dejar de preparar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED179">
              <b-dropdown-item
                v-on:click="showUpdateAuctionAlert(auctionsActionStates.CANCELAR)"
                v-if="auction.estado === auctionsStateCode.publicada"
                data-cy="auction-update-cancel"
              >
                <vs-icon icon="clear"/>
                Cancelar
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED156">
              <b-dropdown-item
                v-on:click="goToAuctionHistory(auction)"
                data-cy="auction-view-history"
                v-if="auction.estado === auctionsStateCode.finalizada ||
                auction.estado === auctionsStateCode.cancelada"
              >
                <vs-icon icon="search"/>
                Ver Historial
              </b-dropdown-item>
            </CheckPermission>
            <CheckPermission permission="ED156">
              <b-dropdown-item
                v-on:click="onDownloadAuction(auction)"
                data-cy="auction-download-history"
                v-if="auction.estado === auctionsStateCode.finalizada ||
                auction.estado === auctionsStateCode.cancelada"
              >
                <vs-icon icon="file_download"/>
                Descargar Historial
              </b-dropdown-item>
            </CheckPermission>
          </b-dropdown>
          <span/>
        </div>
      </slot>
    </div>
    <b-modal
      :id="`receipt-detail-${auction.id}`"
      :title="`Detalles de subasta Nº ${auction.folio}`"
      no-close-on-backdrop
      :ref="`receipt-detail-${auction.id}`"
      size="lg"
      hide-footer
    >
      <AuctionDetail
        :auction="auction"
        :action="action"
        @reload="handleReload"
        v-on:update-auction-status="updateAuctionFromModal"
        v-on:update-auction-status-show-modal="updateAuction"
      />
    </b-modal>
    <ModalBinnacle
      :auction="auction"
      :title="`Bitácora de la subasta Nº ${auction.folio}`"
      :id="`binnacle-${auction.subastaId}`"
      :ref="`binnacle-${auction.subastaId}`"
    />
    <b-modal
      :id="`add-batch-${auction.id}`"
      :title="`Agregar lotes a la subasta Nº ${auction.folio}`"
      no-close-on-backdrop
      :ref="`add-batch-${auction.id}`"
      size="lg"
      hide-footer
    >
      <AuctionDetail
        :auction="auction"
        :action="action"
        v-on:update-auction-status="updateAuctionFromModal"
        v-on:update-auction-status-show-modal="updateAuction"
      />
    </b-modal>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import AuctionDetail from '@/febos/aduanas/auctions/views/components/AuctionDetail';
import ModalBinnacle from '@/febos/aduanas/binnacles/ModalBinnacle';
import { auctionsActionStates, auctionsStateCode } from '@/febos/aduanas/auctions/views/utils/constants';
import { batchesCodeSates } from '@/febos/aduanas/batches/views/utils/constants';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';
import { auctionHistoryList } from '@/febos/servicios/api/aduanas/auctions.api';

export default {
  components: { CheckPermission, AuctionDetail, ModalBinnacle },
  props: [
    'auction',
    'selectAuction'
  ],
  data() {
    return {
      loading: false,
      action: '',
      auctionsActionStates,
      auctionsStateCode,
      batchesCodeSates
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    canPlanify() {
      return (
        this.auction.estado === this.auctionsStateCode.preparacion
        || this.auction.estado === this.auctionsStateCode.planificada
      );
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('auctions', [
      'fetchAuctionBatchesList',
      'updateAuctionStatus'
    ]),
    async onOptionDetailAuction(auction, action) {
      this.action = action;
      this.selectAuction(auction);
      await this.fetchAuctionBatchesList(auction);
      this.$refs[`receipt-detail-${auction.id}`].show();
    },
    async onAddBatchToAuction(auction) {
      this.selectAuction(auction);
      await this.fetchAuctionBatchesList(auction);
      this.$refs[`add-batch-${auction.id}`].show();
    },
    onOptionBinnacle(auction) {
      this.selectAuction(auction);
      this.$refs[`binnacle-${auction.subastaId}`].show(auction.subastaId);
    },
    openBatchForm(auction) {
      this.selectAuction(auction);
      this.$router.push({
        name: 'batchs',
        params: { auctionId: auction.subastaId },
        query: { filters: `estado:${this.batchesCodeSates.disponible}|subastaId:null` }
      });
    },
    goToBatchesFiltered(auction) {
      this.selectAuction(auction);
      const route = this.$router.resolve({
        name: 'batchs',
        query: { filters: `subastaId:${auction.subastaId}` }
      });
      window.open(route.href, '_blank');
    },
    goToReceiptsFiltered(auction) {
      this.selectAuction(auction);
      const route = this.$router.resolve({
        name: 'receipts',
        query: { filters: `subastaId:${auction.subastaId}` }
      });
      window.open(route.href, '_blank');
    },
    async updateAuction(action) {
      await this.updateAuctionStatus({ subastaId: this.auction.subastaId, accion: action });
      this.$vs.notify({
        title: 'Genial!',
        text: 'La subasta se actualizó correctamente',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
    },
    showUpdateAuctionAlert(action) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `¿Estás seguro que deseas ${action} la subasta N° ${this.auction.folio}?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateAuction(action)
      });
    },
    handleReload() {
      this.$emit('reload-list');
    },
    async updateAuctionFromModal(action) {
      await this.updateAuction(action);
      this.$refs[`receipt-detail-${this.auction.id}`].hide();
    },
    goToAuctionHistory(auction) {
      this.selectAuction(auction);
      const route = this.$router.resolve({
        name: 'auctions-history',
        params: { id: auction.subastaId }
      });
      window.open(route.href, '_blank');
    },
    async onDownloadAuction(auction) {
      const auctionId = auction.subastaId;
      this.$vs.notify({
        title: 'Solicitando',
        text: 'Descargando archivo',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'primary',
        position: ALERT_POSITION
      });
      try {
        const { data } = await auctionHistoryList({
          subastaId: auctionId,
          format: 'csv'
        });
        const link = `https://${data.urlHistorial}`;
        window.open(link, '_blank');
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Ocurrió un error al descargar el archivo',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
      }
    }
  }
};

</script>
